import { cookieSizes } from '~/shared/constants/productSizes';

export default function getSizeCookies({
  size_bra: braSizeFilter,
  size_bottom: bottomSizeFilter,
  size_dress: dressSizeFilter,
  size_shoe: shoeSizeFilter,
  size_top: topSizeFilter,
}) {
  return {
    'FL-QUICK-SIZE-BRA':
      braSizeFilter &&
      braSizeFilter.length > 0 &&
      cookieSizes[braSizeFilter[0]],
    'FL-QUICK-SIZE-BOTTOM':
      bottomSizeFilter &&
      bottomSizeFilter.length > 0 &&
      cookieSizes[bottomSizeFilter[0]],
    'FL-QUICK-SIZE-DRESS':
      dressSizeFilter &&
      dressSizeFilter.length > 0 &&
      cookieSizes[dressSizeFilter[0]],
    'FL-QUICK-SIZE-SHOE':
      shoeSizeFilter && shoeSizeFilter.length > 0 && shoeSizeFilter,
    'FL-QUICK-SIZE-TOP':
      topSizeFilter &&
      topSizeFilter.length > 0 &&
      cookieSizes[topSizeFilter[0]],
  };
}
